// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5827fbb6","977":"7c409557"}[chunkId] + ".chunk.js";
};